import {useEffect, useState} from 'react'
import dayjs from "dayjs";

export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  const toggle = () => {
    setIsOpen(!isOpen)
  }
  return {
    isOpen,
    toggle
  }
}

export const useDoubleModal = () => {
  const [douIsOpen, setDouIsOpen] = useState(false)

  const douToggle = () => {
    setDouIsOpen(!douIsOpen)
  }
  return {
    douIsOpen,
    douToggle
  }
}


export const useNoticeModal = (startDt: string, endDt: string) => {
  const flag = () => {
    const sd = dayjs(startDt)
    const ed = dayjs(endDt)
    const now = dayjs()
    return now.isAfter(sd) && now.isBefore(ed)
  }
  return {flag}
}
